import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { OrganizationGuard } from './core/guards/organization.guard';

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "assistant/dashboard",

  },
  {
    path: 'queries',
    loadChildren: () => import('./modules/queries/queries.module').then(m => m.QueriesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'actions',
    loadChildren: () => import('./modules/actions/actions.module').then(m => m.ActionsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'forms',
    loadChildren: () => import('./modules/dynamics-forms/dynamics-forms.module').then(m => m.DynamicsFormsModule),
    canActivate: [AuthGuard],
  },
  {
    path: "users",
    loadComponent: () => import('./core/auth/pages/users/users.component').then(c => c.UsersComponent),
    canActivate: [AuthGuard],
  },
  {
    path: "chat",
    loadChildren: () => import('./modules/chat/chat.module').then(m => m.ChatModule),
  },
  {
    path: "documents",
    loadComponent: () => import('./modules/chat/components/documents-repository/documents-repository.component').then(c => c.DocumentsRepositoryComponent),
  },
  {
    path: "meetings",
    loadComponent: () => import('./modules/chat/components/meetings/meetings.component').then(c => c.MeetingsComponent),
  },
  {
    path: 'recruitment',
    loadComponent: () => import('./modules/recruitment/components/recruitment-process-dashboard/recruitment-process-dashboard.component').then(c => c.RecruitmentProcessDashboardComponent),
    canActivate: [AuthGuard]
  },
    {
    path: 'recruitment/detail/:processId',
    loadComponent: () => import('./modules/recruitment/components/recruitment-process-detail/recruitment-process-detail.component').then(c => c.RecruitmentProcessDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: "candidate-comparison/:stepId",
    loadComponent: () => import('./modules/recruitment/components/candidate-comparison/candidate-comparison.component').then(c => c.CandidateComparisonComponent),
    canActivate: [AuthGuard]
  },

  {
    path: 'dynamic-card/:cardId',
    loadComponent: () => import('./modules/queries/components/dynamic-card/dynamic-card.component').then(c => c.DynamicCardComponent),
  }, // Ruta para el DynamicCardComponent
  {
    path: 'assistant',
    loadChildren: () => import('./modules/assistant/assistant.module').then(m => m.AssistantModule)
  },
  {
    path: ":organizationName/flows",
    loadChildren: () => import('./modules/flows/flows.module').then(m => m.FlowsModule),
    canActivate: [AuthGuard, OrganizationGuard],
  },
  {
    path: ':organizationName/connectors',
    loadChildren: () => import('./modules/connectors/connectors.module').then(m => m.ConnectorsModule),
    canActivate: [AuthGuard, OrganizationGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: "not-found",
    loadComponent: () => import('./share/components/not-found/not-found.component').then(m => m.NotFoundComponent),
    canActivate: [AuthGuard],
  },
  {
    path: ":organizationName",
    loadComponent: () => import('./modules/flows/pages/flows-dashboard/flows-dashboard.component').then(c => c.FlowsDashboardComponent),
    canActivate: [AuthGuard, OrganizationGuard],
  },
  {
    path: "**",
    redirectTo: "not-found",
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      {
        useHash: true,
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        enableTracing: false,
        paramsInheritanceStrategy: 'always',
      })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
